export default function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


//////////////////
// WEBPACK FOOTER
// ./~/babel-preset-react-app/~/@babel/runtime/helpers/esm/arrayWithHoles.js
// module id = 739
// module chunks = 3